import { SS_NAVIGATION_PAYLOAD } from '@/constants';

export type NavigationPayload = {
  url: string;
};

export const getNavigationPayload = () => {
  const payload = sessionStorage.getItem(SS_NAVIGATION_PAYLOAD);
  if (payload) {
    try {
      return JSON.parse(payload) as NavigationPayload;
    } catch (error) {
      console.error('Failed to parse navigation payload:', error);
    }
  }
  return null;
};

export const setNavigationPayload = () => {
  sessionStorage.setItem(
    SS_NAVIGATION_PAYLOAD,
    JSON.stringify({ url: window.location.href }),
  );
};

export const clearNavigationPayload = () => {
  sessionStorage.removeItem(SS_NAVIGATION_PAYLOAD);
};
